export default __webpack_public_path__ + "5a2688a2dc642e05f560f05e39838668.jpg";